import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'; 
import './index.css';
import App from './App';
import store from "./store/index";
import { AxiosSetup } from './utils/helpers/api.helpers';
import { AuthProvider } from './context/AuthContext';
AxiosSetup();
const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <AuthProvider>  
        <App />
      </AuthProvider>
    </BrowserRouter>
  </Provider>
);

